// extracted by mini-css-extract-plugin
export default {"root":"styles_root__4Hw2A","input":"styles_input__Oi8VZ","blackColor":"styles_blackColor__h3p7h"};